import Highcharts from "highcharts/highmaps";

const COMMON_HC_OPTIONS: Partial<Highcharts.Options> = {
  colorAxis: {
    maxColor: "#005645",
    min: 0,
    minColor: "#E6E7E8",
  },
  credits: {
    enabled: false,
  },
  drilldown: {
    activeDataLabelStyle: {
      color: "#FFFFFF",
      textDecoration: "none",
      textOutline: "1px #000000",
    },
    drillUpButton: {
      position: {
        x: 0,
        y: -10,
      },
      relativeTo: "spacingBox",
    },
  },
  legend: {
    align: "left",
    layout: "vertical",
    verticalAlign: "middle",
  },
  mapNavigation: {
    buttonOptions: {
      verticalAlign: "bottom",
    },
    enabled: true,
  },
  plotOptions: {
    map: {
      states: {
        hover: {
          color: "#EEDD66",
        },
      },
    },
  },
  title: {
    text: "",
  },
};

export default COMMON_HC_OPTIONS;
